<div class="mb-5">
  <label class="form-label">
    {{ label | translate }}
  </label>

  <ng-select [items]="items" [typeahead]="typeahead" [bindLabel]="bindLabel" [formControl]="control" [bindValue]="bindValue"
    [attr.name]="controlName" [class.is-invalid]="isControlInvalid()" [class.is-valid]="isControlValid()" (scrollToEnd)="onScrollToEnd()"
    [placeholder]="placeholder | translate" (change)="onChange($event)">
  </ng-select>
  <div class="valid-feedback" *ngIf="isControlValid()">
    {{ label | translate }} {{ 'MENU.Correct' | translate }}
  </div>
  <div class="invalid-feedback" *ngIf="controlHasError('required')">
    {{ label | translate }} {{ 'MENU.IsRequired' | translate }}
  </div>
</div>
